import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  CssBaseline
} from '@mui/material';
import boschLogo from '../imgs/jpgs/bosch-service.jpeg';
import BuildIcon from '@mui/icons-material/Build';
import HandshakeIcon from '@mui/icons-material/Handshake';
import DescriptionIcon from '@mui/icons-material/Description';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import renaultLogo from '../imgs/svgs/renault-3.png';
import fiatLogo from '../imgs/svgs/fiat-6.png';
import hondaLogo from '../imgs/svgs/honda-5.png';
import peugeotLogo from '../imgs/svgs/peugeot-1.png';
import mercedesBenzLogo from '../imgs/svgs/mercedes-benz-4.png';
import fordLogo from '../imgs/svgs/ford-7.png';
import vwLogo from '../imgs/svgs/volkswagen-2.png';
import visaLogo from '../imgs/svgs/visa-logo.png';
import amexLogo from '../imgs/svgs/amex-logo.png';
import masterLogo from '../imgs/svgs/mastercard-logo.png';
import mercadopagoLogo from '../imgs/svgs/mercado-pago.png';
import especialistasBg from '../imgs/svgs/especialistas_bg.webp';
import { SERVICES_BG } from '../styles/colors';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import climatizacionAutomotor from '../imgs/jpgs/climatizacion-automotor.webp';
import mecanicaIntegral from '../imgs/jpgs/mecanica-integral.jpg';
import service from '../imgs/jpgs/service.jpg';
import correaDistribucion from '../imgs/jpgs/correa-distribucion.jpg';
// import inyeccionElectronica from '../imgs/jpgs/inyeccion-electronica.jpg';
// Comentado: imagen usada por la sección 'Inyección / Sincronización de Airbag'.
// Se conserva import comentada para facilitar restauración si se decide reactivar la sección.
import { Link } from 'react-router-dom';

const Slider = React.lazy(() => import('react-slick'));

const Home = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

const handleScrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.location.hash = sectionId; 
  }
  setDrawerOpen(false); 
};
  // Home-specific logic here
  useEffect(() => {
  if (window.location.hash) {
    const sectionId = window.location.hash.replace('#', '');
    const section = document.getElementById(sectionId);
    if (section) {
      setTimeout(() => {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }
  }
}, []);

  return (
    <>
      <CssBaseline />
      <AppBar position="sticky" sx={{ backgroundColor: '#ffffff', boxShadow: 'none' }}>
      <AppBar position="sticky" sx={{ backgroundColor: '#ffffff', boxShadow: 'none' }}>
<Toolbar sx={{ backgroundColor: '#003366' }}>
  <img style={{ cursor: 'pointer', height: '40px', width: 'auto', marginRight: '10px' }} onClick={() => window.location.href = 'https://www.mecamotor.com.ar/'} src={boschLogo} alt="Bosch Logo" width={474} height={583} />
  <Box>
    <Typography variant="h6" component="span" sx={{ fontWeight: 'bold', fontSize: '24px', color: '#ffffff', display: 'block', flexGrow: 1 }}>
      MECAMOTOR TALLER
    </Typography>
    <Typography variant="body2" style={{ color: '#ffffff', fontSize: '12px' }}>
      Taller mecánico en Villa Devoto, CABA
    </Typography>
    <Typography   onClick={() => window.location.href = 'tel:+541131601909'}
 variant="body2"   style={{ color: '#ffffff', fontSize: '12px', cursor: 'pointer' }}
>
      Av San Martin 7354 | Tel: +54 11 3160-1909
    </Typography>
  </Box>
  {/* Botones de navegación para pantallas grandes */}
  <Box
    sx={{
      display: { xs: 'none', md: 'flex' },
      marginLeft: 'auto',
    }}
  >
<Box
    sx={{
      display: { xs: 'none', md: 'flex' },
      marginLeft: 'auto',
      gap: 2,
    }}
  >
    <Button color="inherit" onClick={() => handleScrollToSection('hero-heading')}>
      Inicio
    </Button>
    <Button color="inherit" onClick={() => handleScrollToSection('services-heading')}>
      Servicios
    </Button>
    <Button color="inherit" onClick={() => handleScrollToSection('porque-elegirnos')}>
      ¿Por qué elegirnos?
    </Button>
    <Button color="inherit" onClick={() => handleScrollToSection('marcas')}>
      Marcas
    </Button>
    <Button color="inherit" onClick={() => handleScrollToSection('contacto')}>
      Contacto
    </Button>
  </Box>  </Box>
  {/* Botón de menú para dispositivos móviles */}
  <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
    <IconButton
      edge="end"
      color="inherit"
      aria-label="menu"
      onClick={handleDrawerToggle}
    >
      <MenuIcon />
    </IconButton>
  </Box>
</Toolbar>
      </AppBar>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleScrollToSection('hero-heading')}>
              <ListItemText primary="Inicio" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleScrollToSection('services-heading')}>
              <ListItemText primary="Servicios" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleScrollToSection('porque-elegirnos')}>
              <ListItemText primary="¿Por qué elegirnos?" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleScrollToSection('marcas')}>
              <ListItemText primary="Marcas" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleScrollToSection('contacto')}>
              <ListItemText primary="Contacto" />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
      </AppBar>
<main>
{/* HERO SECTION */}
<Box
  component="section"
  aria-labelledby="hero-heading"
  sx={{
    px: { xs: 2, sm: 4, md: 0 },
    py: { xs: 4, md: 4 },
    minHeight: { xs: 500, md: 400 },
    backgroundImage: `url(${process.env.PUBLIC_URL}/mainHeroSection.webp)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
  }}
>
  <Typography
    id="hero-heading"
    variant="h2"
    component="h1"
    sx={{
      fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
      mb: 1,
      textShadow: '0 2px 8px #0008',
      textAlign: 'center',
      wordBreak: 'break-word',
    }}
  >
    Tu taller mecánico oficial
  </Typography>
  <Typography
    variant="h5"
    component="h2"
    sx={{
      fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
      mb: 3,
      textShadow: '0 2px 8px #0008',
      textAlign: 'center',
    }}
  >
    Mecánica integral y tecnología de diagnóstico
  </Typography>
  <Typography
    variant="subtitle1"
    sx={{
      fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.15rem' },
      mb: 2,
      textShadow: '0 2px 8px #0008',
      textAlign: 'center',
    }}
  >
    Servicio especializado Volkswagen, Audi, Peugeot, Citroën — motores THP y cadena de distribución
  </Typography>
  <Box
    sx={{
      mt: 2,
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      width: '100%',
      maxWidth: 400,
    }}
  >
{/* <Button
  id="boton-llamanos"
  className="boton-llamanos"
  variant="contained"
  color="primary"
  size="large"
  onClick={() => window.location.href = 'tel:+541131601909'}
  sx={{
    width: '100%',
    minWidth: 0,
    height: '50px',
    fontSize: { xs: '1rem', sm: '1.1rem' },
    lineHeight: 1,
    p: 0,
  }}
>
  <span style={{ display: 'block', lineHeight: 1, paddingTop: 2 }}>
    LLAMANOS<br />AHORA
  </span>
</Button> */}

<Button
  id="boton-whatsapp"
  className="boton-whatsapp"
  variant="contained"
  color="success"
  size="large"
  onClick={() => window.open('https://wa.me/+5491131601909', '_blank')}
  sx={{
    width: '100%',
    minWidth: 0,
    height: '50px',
    fontSize: { xs: '1rem', sm: '1.1rem' },
  }}
>
  WhatsApp
</Button>
  </Box>
  {/* Medios de pago */}
  <Box
    sx={{
      mt: 4,
      background: 'rgba(0,0,0,0.5)',
      borderRadius: 2,
      px: 2,
      py: 2,
      width: { xs: '100%', sm: 'auto' },
      maxWidth: 400,
      textAlign: 'center',
      boxShadow: 2,
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontWeight: 'bold',
        mb: 2,
        color: '#fff',
        fontSize: { xs: '0.95rem', sm: '1rem' },
      }}
    >
      ACEPTAMOS TODOS LOS MEDIOS DE PAGO: CRÉDITO, DÉBITO, TRANSFERENCIA, MERCADOPAGO
    </Typography>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <img src={visaLogo} alt="Visa" width={50} height={43} loading="lazy" style={{ maxWidth: 60, maxHeight: 36, objectFit: 'contain' }} />
      <img src={amexLogo} alt="American Express" width={43} height={43} loading="lazy" style={{ maxWidth: 60, maxHeight: 36, objectFit: 'contain' }} />
      <img src={masterLogo} alt="MasterCard" width={68} height={43} loading="lazy" style={{ maxWidth: 60, maxHeight: 36, objectFit: 'contain' }} />
      <img src={mercadopagoLogo} alt="MercadoPago" width={108} height={43} loading="lazy" style={{ maxWidth: 60, maxHeight: 36, objectFit: 'contain' }} />
    </Box>
  </Box>
</Box>

{/* especialistas */}
<Box
  component="section"
  id="especialistas"
  sx={{
    width: '100vw',
    backgroundColor: SERVICES_BG,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    py: 8,
  }}
>
  <Box sx={{ px: { xs: 2, sm: 4, md: 8 } }}>
    <Typography id="services-heading" variant="h4" component="h2" sx={{ fontWeight: 'bold', color: '#003366', mb: 6 }}>
      Nuestros Servicios
    </Typography>
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 4,
      }}
    >
{[
  /*
    Servicio relacionado con Airbags comentado intencionalmente.
    Nota: Se comenta la sección para ocultar en la web mientras se revisa el contenido/legalidad
    o se decide si debe mostrarse. Mantengo el bloque comentado para que el equipo sepa qué hace
    y pueda restaurarlo fácilmente cuando corresponda.
  */
  {
    id: 'climatizacion',
    icon: <CleaningServicesIcon sx={{ fontSize: 50, color: '#003366' }} />,
    title: 'Climatización',
        desc: (
      <ul>
        <li>Cargas de gas, prueba hidráulica de pérdidas</li>
        <li>Reparación de circuitos, cambio de mangueras y caños</li>
        <li>Compresores nuevos</li>
      </ul>
    ),
    bg: `url(${climatizacionAutomotor})`,
  },
  {
  id: 'mecanica',
    icon: <HandshakeIcon sx={{ fontSize: 50, color: '#003366' }} />,
    title: 'Mecánica Automotor Integral',
    desc: (
      <ul>
        <li>Cambio de correas y cadenas de distribución, correas de accesorios</li>
        <li>Frenos: Cambio de pastillas y discos, sistema ABS</li>
        <li>Embragues: reparaciones y cambio del mismo</li>
        <li>Motor: despiece, reparación, rectificación, tapas de cilindro, entre otros</li>
        <li>Suspensión: Cambio de amortiguadores, extremos, rótulas</li>
        <li>Motores turbo comprimidos</li>
      </ul>
    ),
    bg: `url(${mecanicaIntegral})`,
  },
  {
  id: 'correa-distribucion',
    icon: <BuildIcon sx={{ fontSize: 50, color: '#003366' }} />,
    title: 'Cambio de Correa de Distribución',
    desc: (
      <ul>
        <li>Cambio de correa de distribución, todas las marcas</li>
        <li>Reemplazo de tensores, poleas y bomba de agua</li>
        <li>Revisión completa del sistema antes y después del cambio</li>
      </ul>
    ),
    bg: `url(${correaDistribucion})`,
  },
  {
  id: 'service',
    icon: <ReceiptLongIcon sx={{ fontSize: 50, color: '#003366' }} />,
    title: 'Service',
    desc: (
      <ul>
        <li>Cambios de filtros y aceite</li>
        <li>Revisión de luces y escobillas</li>
        <li>Chequeo de tren delantero y frenos</li>
      </ul>
    ),
    bg: `url(${service})`,
  },
].map((service, i) => (
  <Link key={service.id || i} to={`/services/${service.id || i}`} style={{ textDecoration: 'none' }}>
    <Box
      key={service.id || i}
    sx={{
      backgroundColor: '#fff',
      backgroundImage: `${service.bg}`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: { xs: 3, md: 5 },
      borderRadius: 3,
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.08)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: { xs: '90vw', sm: '420px', md: '480px' },
      height: { xs: '420px', md: '520px' },
      overflow: 'hidden',
      border: '1px solid #e0e0e0',
      position: 'relative',
      cursor: 'pointer',
      '&:hover .hoverOverlay': {
        transform: 'translateY(0)',
        opacity: 1,
      },
    }}
  >
    {/* Title bar at bottom (visible by default) */}
    <Box sx={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, rgba(0,51,102,0.92) 0%, rgba(0,51,102,0.95) 100%)',
      color: '#fff',
      px: 2,
      py: 1.5,
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>{service.title}</Typography>
      <Typography variant="subtitle2" aria-hidden sx={{ opacity: 0.85 }}>➜</Typography>
    </Box>

    {/* Hover overlay with description */}
    <Box className="hoverOverlay" sx={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, rgba(0,51,102,0.94) 0%, rgba(26,77,145,0.94) 100%)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left',
      px: { xs: 2, md: 4 },
      transform: 'translateY(100%)',
      opacity: 0,
      transition: 'all .35s ease',
      zIndex: 3,
    }}>
      <Typography variant="h6" component="h3" sx={{ fontWeight: 800, mb: 1 }}>{service.title}</Typography>
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Typography variant="body2" component="div" sx={{ lineHeight: 1.6 }}>
          {service.desc}
        </Typography>
      </Box>
    </Box>
    </Box>
  </Link>
))}
    </Box>
  </Box>
</Box>
{/* PORQUE ELEGIRNOS */}
<Box
  component="section"
  id="porque-elegirnos"
  sx={{
    width: '100vw',
    py: 8,
    backgroundImage: `url(${especialistasBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }}
>
  <Typography variant="h4" component="h2" sx={{ margin: '40px 0', textAlign: 'center', fontWeight: 'bold', color: '#fff', textShadow: '0 2px 8px #0008' }}>
    ¿Por qué elegir <em>Mecamotor Taller</em>?
  </Typography>
  <Typography variant="subtitle1" align="center" sx={{ color: '#fff', mb: 6, textShadow: '0 2px 8px #0008' }}>
    Contamos con años de experiencia en el rubro ofreciendo servicio especializado de alta calidad
  </Typography>
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 4,
      justifyContent: 'center',
      px: { xs: 2, sm: 6, md: 12 },
    }}
  >
    {[
      {
        icon: <BuildIcon sx={{ fontSize: 50, color: '#ffffff' }} />,
        title: 'Tecnología de punta',
        desc: 'Equipos de diagnóstico y herramientas modernas para solucionar cualquier problema de tu vehículo.',
      },
      {
        icon: <HandshakeIcon sx={{ fontSize: 50, color: '#ffffff' }} />,
        title: 'Atención personalizada',
        desc: 'Cada cliente es único. Nos enfocamos en brindarte la mejor atención posible.',
      },
      {
        icon: <DescriptionIcon sx={{ fontSize: 50, color: '#ffffff' }} />,
        title: 'Presupuestos claros',
        desc: 'Dejamos por escrito el detalle de la mano de obra, repuestos y precios.',
      },
      {
        icon: <CleaningServicesIcon sx={{ fontSize: 50, color: '#ffffff' }} />,
        title: 'Ambiente limpio y ordenado',
        desc: 'Tu vehículo es atendido en un entorno profesional y cuidado.',
      },
      {
        icon: <ReceiptLongIcon sx={{ fontSize: 50, color: '#ffffff' }} />,
        title: 'Historial de mantenimiento',
        desc: 'Llevamos registro de los trabajos realizados a tu auto.',
      },
    ].map((item, i) => (
 <Box
  key={i}
  sx={{
    width: { xs: '90vw', sm: 260, md: 280 },
    minHeight: 200,
    backgroundColor: 'rgba(0,51,102,0.92)',
    color: '#fff',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 3,
    border: '1px solid #fff',
    boxShadow: '0 8px 32px 0 rgba(0,0,0,0.25)',
    m: 2,
    mb: '20px',
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    wordBreak: 'break-word',
  }}
>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 60,
      mb: 1,
    }}
  >
    {item.icon}
  </Box>
  <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1, fontSize: '1.1rem' }}>
    {item.title}
  </Typography>
  <Typography variant="body2" sx={{ fontSize: '0.98rem', whiteSpace: 'pre-line' }}>
    {item.desc}
  </Typography>
</Box>
    ))}
  </Box>
</Box>


{/* MARCAS */}
<Box
  component="section"
  id="marcas"
  sx={{
    mt: 10,
    mb: 8,
    textAlign: 'center',
    padding: { xs: 2, sm: 4, md: 8 },
    backgroundColor: '#f5f5f5',
  }}
>
  <Typography variant="h3" component="h2" sx={{ margin: '40px 0', textAlign: 'center', fontWeight: 'bold', color: '#003366' }}>
    Trabajamos con todas las marcas
  </Typography>
  <Typography variant="body1" sx={{ mt: 2, mb: 4 }}>
    Asistimos todas las marcas del mercado actual: Renault, Fiat, Ford, VW, Chevrolet, Peugeot, Citroën.
  </Typography>
  <React.Suspense fallback={<Box sx={{ minHeight: 140 }} />}>
  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={4}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={true}
    responsive={[
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ]}
  >
    {[renaultLogo, fiatLogo, fordLogo, vwLogo, hondaLogo, peugeotLogo, mercedesBenzLogo].map((logo, i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 2,
        }}
      >
        <img
          src={logo}
          alt={`Logo ${i}`}
          width={167}
          height={89}
          loading="lazy"
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </Box>
    ))}
  </Slider>
  </React.Suspense>
</Box>
</main>
<Box
  component="footer"
    id="contacto"
  sx={{
    backgroundColor: '#003366',
    color: '#ffffff',
    py: 4,
    textAlign: 'center',
  }}
>
  <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
    MECAMOTOR - Taller Mecánico Oficial Bosch
  </Typography>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Taller mecánico en Villa Devoto, CABA
  </Typography>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Dirección: Av San Martin 7354
  </Typography>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Teléfono: <a href="tel:+541131601909" style={{ color: '#ffffff', textDecoration: 'none' }}>+54 11 3160-1909</a>
  </Typography>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Horario de atención: Lunes a viernes de 08:30 a 17:00 hs
  </Typography>
 <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
  {/* <Button
    id="footer-llamanos"
    className="footer-llamanos"
    variant="contained"
    color="primary"
    size="large"
    onClick={() => window.location.href = 'tel:+541131601909'}
    sx={{
      width: '200px',
      height: '50px',
    }}
  >
    Llamanos Ahora
  </Button>
  <Button
    id="footer-whatsapp"
    className="footer-whatsapp"
    variant="contained"
    color="success"
    size="large"
    onClick={() => window.open('https://wa.me/+5491131601909', '_blank')}
    sx={{
      width: '200px',
      height: '50px',
    }}
  >
    WhatsApp
  </Button> */}
</Box>
</Box>
      
      </>
  );
};

export default Home;